import { render, staticRenderFns } from "./FundraisingGoalsSetup.vue?vue&type=template&id=262ba13a&scoped=true&"
import script from "./FundraisingGoalsSetup.vue?vue&type=script&lang=ts&"
export * from "./FundraisingGoalsSetup.vue?vue&type=script&lang=ts&"
import style0 from "./FundraisingGoalsSetup.vue?vue&type=style&index=0&id=262ba13a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262ba13a",
  null
  
)

export default component.exports